module.exports = __webpack_public_path__ + "img/vg.114550e8.svg";